import { createContext, useState, useContext } from "react";
import ModalRoot from "../components/modal/ModalRoot";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [activeModal, setActiveModal] = useState(null);

    const openModal = (modalName) => setActiveModal(modalName);
    const closeModal = () => {
        if (activeModal) {
            // Segna come "visto" se il modale non deve ricomparire
            localStorage.setItem(`modalSeen_${activeModal}`, "true");
        }
        setActiveModal(null);
    };

    const hasSeenModal = (modalName) => {
        return localStorage.getItem(`modalSeen_${modalName}`) === "true";
    };

    return (
        <ModalContext.Provider
            value={{ activeModal, openModal, closeModal, hasSeenModal }}
        >
            {children}
            <ModalRoot />
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);

export default ModalContext;
